import { TransaltionsBannerType } from "types/Banners";

export const getBannerTranslations = (
  translations: TransaltionsBannerType[],
  lang: string,
) => {
  // eslint-disable-next-line no-param-reassign
  lang = lang.toLowerCase();

  const detailsTranslation = translations?.find(
    (t) => t.language.toLowerCase() === lang,
  ) ||
    translations?.find((t) => t.language.toLowerCase() === "en") || {
      titleMob: "",
      titleDesktop: "",
      buttonName: "",
      descriptionMob: "",
      descriptionDesktop: "",
    };

  return {
    descriptionMob: detailsTranslation.descriptionMob || "",
    descriptionDesktop: detailsTranslation.descriptionDesktop || "",
    titleMob: detailsTranslation.titleMob || "",
    titleDesktop: detailsTranslation.titleDesktop || "",
    buttonName: detailsTranslation.buttonName || "",
  };
};
